import React from 'react';
import clsx from 'clsx';
import {Link} from '@shopify/hydrogen';
import {
  Disclosure,
  RadioGroup,
  Switch,
  Popover,
  Transition,
  // @ts-expect-error @headlessui/react incompatibility with node16 resolution
} from '@headlessui/react';
import SanityImage from './SanityImage.client';
import sanityConfig from '../../../sanity.config';
import PortableText from '../portableText/PortableText.client';

//components
import LanguageSelect from './LanguageSelect.client';
import CurrencySelect from './CurrencySelect.client';

//types
import type {Brand} from '../../types';

interface Props {
  menu: any;
  allBrands: Brand[] | undefined;
  business: any;
}

export default function MenuMobile({menu, allBrands, business}: Props) {
  const alpha = Array.from(Array(26)).map((e, i) => i + 65);
  const alphabets = alpha.map((x) => String.fromCharCode(x));
  const availableAlphabets = alphabets.filter((a) =>
    allBrands
      ?.map((b) => b.title.toUpperCase()?.replace(/\s/g, '').charAt(0))
      .includes(a),
  );
  const brandsByInitials = [
    {
      initials: '#',
      brands: allBrands?.filter(
        (b) =>
          !availableAlphabets.includes(
            b?.title?.replace(/\s/g, '').charAt(0)?.toUpperCase(),
          ),
      ),
    },
  ].concat(
    availableAlphabets.map((a) => {
      return {
        initials: a,
        brands: allBrands?.filter(
          (b) =>
            b?.title?.replace(/\s/g, '')?.charAt(0)?.toLocaleLowerCase() ===
            a.toLocaleLowerCase(),
        ),
      };
    }),
  );
  return (
    <div className="mobile-menu flex h-full flex-col justify-between overflow-y-scroll pt-5">
      <div className="px-5">
        <div className="flex items-center space-x-2">
          <LanguageSelect />
          <CurrencySelect />
        </div>
        <ul className="grid">
          {menu &&
            menu.map((item: any) => {
              return (
                <li
                  key={item._key}
                  className={clsx([
                    'relative py-4 transition-all duration-200 ease-out hover:text-hk-orange',
                    item.title === 'Sale' && 'text-hk-red',
                  ])}
                >
                  {item._type === 'linkMegaMenu' ? (
                    <>
                      <Disclosure>
                        {({open}) => (
                          <>
                            <Disclosure.Button className="flex w-full items-center justify-between">
                              <span className="block w-full whitespace-nowrap text-left text-sm uppercase tracking-wide">
                                {item.title}
                              </span>
                              <div className="">
                                {open ? (
                                  <svg
                                    width="13"
                                    height="3"
                                    viewBox="0 0 13 3"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12.0851 0.659999V2.816H0.913063V0.659999H12.0851Z"
                                      fill="black"
                                    />
                                  </svg>
                                ) : (
                                  <svg
                                    width="15"
                                    height="15"
                                    viewBox="0 0 15 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M6.31536 0.611999V6.688H0.37936V8.844H6.31536V14.892H8.69536V8.844H14.6594V6.688H8.69536V0.611999H6.31536Z"
                                      fill="black"
                                    />
                                  </svg>
                                )}
                              </div>
                            </Disclosure.Button>

                            <Transition
                              show={open}
                              enter="transition-all duration-300"
                              enterFrom="opacity-0 translate-x-4"
                              enterTo="opacity-100 translate-x-0"
                              leave="transition-all duration-300"
                              leaveFrom="opacity-100 translate-x-0"
                              leaveTo="opacity-0 translate-x-4"
                            >
                              <div className="bg-white py-4 text-black">
                                <div
                                  className={clsx('relative grid gap-8 pl-5')}
                                >
                                  {item?.col_1_links && (
                                    <LinkGroup links={item.col_1_links.links} />
                                  )}
                                  {item?.col_2_links && (
                                    <LinkGroup links={item.col_2_links.links} />
                                  )}
                                  {item?.col_3_links && (
                                    <LinkGroup links={item.col_3_links.links} />
                                  )}
                                  {item?.col_4_links && (
                                    <LinkGroup links={item.col_4_links.links} />
                                  )}
                                  {item?.col_5_links && (
                                    <LinkGroup links={item.col_5_links.links} />
                                  )}
                                </div>
                              </div>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                    </>
                  ) : item.title === 'All Brands' ? (
                    <Disclosure>
                      {({open}) => (
                        <>
                          <Disclosure.Button className="flex w-full items-center justify-between">
                            <span className=" text-sm">{item.title}</span>
                            <div className="">
                              {open ? (
                                <svg
                                  width="13"
                                  height="3"
                                  viewBox="0 0 13 3"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M12.0851 0.659999V2.816H0.913063V0.659999H12.0851Z"
                                    fill="black"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="15"
                                  height="15"
                                  viewBox="0 0 15 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6.31536 0.611999V6.688H0.37936V8.844H6.31536V14.892H8.69536V8.844H14.6594V6.688H8.69536V0.611999H6.31536Z"
                                    fill="black"
                                  />
                                </svg>
                              )}
                            </div>
                          </Disclosure.Button>
                          <Disclosure.Panel>
                            <div className=" bg-white py-4 text-black">
                              <div className="relative grid gap-8 pl-5">
                                {brandsByInitials &&
                                  brandsByInitials.map((b) => {
                                    return (
                                      <div
                                        key={`mobile-menu-brands-${b}`}
                                        className=""
                                      >
                                        <span className="">{b.initials}</span>
                                        <ul className="">
                                          {b.brands &&
                                            b.brands.map((brand) => {
                                              return (
                                                <li
                                                  key={`mobile-menu-brand-${brand.shopify_brand_node}`}
                                                  className=""
                                                >
                                                  <Link
                                                    to={`/collections/vendor?q=${brand.shopify_brand_node}`}
                                                  >
                                                    <Popover.Button>
                                                      <span className="font-light">
                                                        {brand.title}
                                                      </span>
                                                    </Popover.Button>
                                                  </Link>
                                                </li>
                                              );
                                            })}
                                        </ul>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          </Disclosure.Panel>
                        </>
                      )}
                    </Disclosure>
                  ) : (
                    <Link
                      to={`${item.slug}`}
                      className="whitespace-nowrap text-sm"
                    >
                      <Popover.Button>{item.title}</Popover.Button>
                    </Link>
                  )}
                  <div className="absolute bottom-0 left-0 w-full scale-x-105 border-t border-hk-deep-gray"></div>
                </li>
              );
            })}
        </ul>
      </div>
      <MobileMenuFooter business={business} />
    </div>
  );
}

function MobileMenuFooter({business}: {business: any}) {
  return (
    <div className="mt-10 bg-hk-deep-blue p-5 text-white">
      {business.footer_links &&
        business?.footer_links
          ?.filter((l:any) => l.title === 'Contact Us')
          ?.map((l: any) => {
            if (l._type === 'custom.footerLinkGroup')
              return (
                <div key={l._key} className="lg:col-span-1">
                  <h3 className="mb-8 font-bold tracking-wide">
                    {l.title}
                  </h3>
                  <ul className="grid gap-4">
                    {l.links &&
                      l.links?.map((link: any) => {
                        if (link._type === 'custom.linkWithIcon') {
                          return (
                            <li key={link._key} className="font-normal">
                              <a
                                href={link.url}
                                target="_blank"
                                rel="noreferrer noopener"
                                className="flex items-center space-x-2"
                              >
                                <div className="w-[22px]">
                                  <SanityImage
                                    dataset={sanityConfig.dataset}
                                    layout="responsive"
                                    projectId={sanityConfig.projectId}
                                    sizes={['50vw, 100vw']}
                                    src={link.icon?.asset._ref}
                                  />
                                </div>
                                <span className="">{link?.icon_title}</span>
                              </a>
                            </li>
                          );
                        }
                        if (link._type === 'block') {
                          return (
                            <li key={link._key} className="font-normal">
                              <PortableText blocks={link} />
                            </li>
                          );
                        }
                        if (link._type === 'linkInternal') {
                          // my account
                          if (link._key === 'c946eaece34c') {
                            return (
                              <li key={link._key} className="font-normal">
                                <Link to={`/account`}>{link.title}</Link>
                              </li>
                            );
                          }
                          return (
                            <li key={link._key} className="font-normal">
                              <Link
                                to="/"
                                // to={`${generateSanityInternalPath({
                                //   type: link?.reference?._type,
                                //   slug: link?.reference?.slug?.current,
                                // })}`}
                              >
                                {link.title}
                              </Link>
                            </li>
                          );
                        }
                      })}
                  </ul>
                </div>
              );
            return;
          })}
    </div>
  );
}

interface LinkGroupProps {
  links: any;
}

const LinkGroup: React.FC<LinkGroupProps> = ({links}) => {
  const indexOfAllGroupsFirstItem =
    links &&
    links.reduce(function (a: any, e: any, i: number) {
      if (e.is_group) a.push(i);
      return a;
    }, []);

  return (
    <div className="">
      <div className="grid gap-4">
        {links.map((l: any, index: number) => {
          return (
            <div
              key={l._key}
              className={clsx([
                `${l.is_group ? 'font-semibold underline' : 'font-light'}`,
                `${
                  indexOfAllGroupsFirstItem.includes(index) &&
                  index !== 0 &&
                  'mt-4'
                }`,
                'text-sm tracking-wide',
              ])}
            >
              <Link to={l.slug ? l.slug : ''}>
                <Popover.Button>{l.title}</Popover.Button>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};
